module.exports = __webpack_public_path__ + "img/axel.bdaf1ae9.jpeg";